import React from 'react';
import { geocodeAddress } from './LogisticsUtils';
import { Icon } from './LogisticsUtils';

const SucursalSelectionModal = ({
  contact,
  existingDestinations = [],
  onSelect,
  onClose,
  showMessage
}) => {
  if (!contact) return null;

  const existingAddresses = new Set(
    (existingDestinations || []).map((d) => d.address)
  );

  const handleSelectSucursal = async (selectedContact, address) => {
    if (!address.latlng) {
      const fullAddressParts = [
        address.address,
        address.apartment,
        address.locality,
        address.partido,
        address.province,
        address.postalCode
      ].filter(Boolean);

      const fullAddress = fullAddressParts.join(', ');
      const coords = await geocodeAddress(fullAddress, showMessage);

      if (coords) {
        onSelect(selectedContact, { ...address, latlng: coords });
      } else {
        showMessage?.(
          'No se pudieron obtener las coordenadas para esta sucursal. Intentá editar el contacto.',
          'error'
        );
      }
    } else {
      onSelect(selectedContact, address);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/50 p-4 backdrop-blur-[2px]"
      onClick={onClose}
    >
      <div
        className="w-full max-w-2xl overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="border-b border-slate-200 px-6 py-5">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-slate-500">
                Base operativa
              </p>
              <h3 className="mt-2 text-2xl font-bold tracking-[-0.03em] text-slate-900">
                Seleccionar sucursal
              </h3>
              <p className="mt-2 text-sm text-slate-500">
                Elegí la ubicación que querés incorporar a la hoja para <span className="font-semibold text-slate-700">{contact.name}</span>.
              </p>
            </div>

            <button
              onClick={onClose}
              className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-600 transition hover:bg-slate-200"
            >
              <Icon path="M6 18L18 6M6 6l12 12" className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="max-h-[70vh] overflow-y-auto px-6 py-5">
          <div className="space-y-3">
            {(contact.addresses || []).map((addr, index) => {
              const isAdded = existingAddresses.has(addr.address);

              return (
                <button
                  key={index}
                  onClick={() => !isAdded && handleSelectSucursal(contact, addr)}
                  disabled={isAdded}
                  className={`w-full rounded-[24px] border p-4 text-left transition-all ${
                    isAdded
                      ? 'cursor-not-allowed border-slate-200 bg-slate-100 text-slate-400'
                      : 'border-slate-200 bg-slate-50 hover:-translate-y-0.5 hover:border-blue-200 hover:bg-blue-50 hover:shadow-md'
                  }`}
                >
                  <div className="flex items-start justify-between gap-4">
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-full bg-white px-2.5 py-1 text-[11px] font-semibold text-slate-700 shadow-sm">
                          Sucursal {index + 1}
                        </span>

                        {isAdded && (
                          <span className="rounded-full bg-slate-200 px-2.5 py-1 text-[11px] font-semibold text-slate-500">
                            Ya agregada
                          </span>
                        )}
                      </div>

                      <p className="mt-3 font-semibold text-slate-800">
                        {addr.address} {addr.apartment ? `(${addr.apartment})` : ''}
                      </p>

                      <p className="mt-1 text-sm text-slate-600">
                        {[addr.locality, addr.partido, addr.province, addr.postalCode]
                          .filter(Boolean)
                          .join(', ')}
                      </p>

                      {addr.latlng ? (
                        <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700">
                          <span className="h-2 w-2 rounded-full bg-emerald-500" />
                          Coordenadas disponibles
                        </div>
                      ) : (
                        <div className="mt-3 inline-flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 px-3 py-1 text-xs font-semibold text-rose-600">
                          <span className="h-2 w-2 rounded-full bg-rose-500" />
                          Sin coordenadas, se intentarán generar al seleccionar
                        </div>
                      )}
                    </div>

                    {!isAdded && (
                      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-blue-600 shadow-sm">
                        <Icon path="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" className="h-5 w-5" />
                      </div>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex justify-end border-t border-slate-200 px-6 py-5">
          <button
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-2xl border border-slate-200 bg-slate-100 px-4 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-200"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SucursalSelectionModal;